import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import constants from '../constants';
import { add, remove, setQuantity } from './../Actions/ShoppingList.action';
import { translate } from '../Services/translation';
import { googleAnalytics } from '../Services/googleAnalytics';

const ReorderButton = ({ productId, isSmall, isSticky, onClick }) => {
    const shoppingList = useSelector((x) => x.shoppingList);

    return (
        <button
            className={`shoppinglist__button ${isSmall ? 'shoppinglist__button--small' : ''
                } ${isSticky ? 'shoppinglist__button--sticky' : ''} ${constants.isClickAndCollect ? 'shoppinglist__button--green' : ''}`}
            onClick={() => onClick({ productId, shoppingList })}
            aria-label={translate('button.addToShoppingList')}
        >
            {isSmall && !shoppingList.some((x) => x.productId == productId) && (
                <img 
                    src="/ui/images/heart.svg" 
                    className="shoppinglist__icon" 
                    alt="favorite-icon" 
                />
            )}
            {isSmall && shoppingList.some((x) => x.productId == productId) && (
                <img 
                    src="/ui/images/heart-filled.svg" 
                    className="shoppinglist__icon" 
                    alt="filled-favorite-icon" 
                />
            )}
            {!isSmall && translate('button.addToShoppingList')}
        </button>
    );
};

function isJSONString(obj){
    try {
        JSON.parse(obj)
        return true
    } catch (error) {
        return false
    }
}

const StyledButton = (props) => {
    const dispatch = useDispatch();
    const onClick = ({ productId, shoppingList }) => {
        const products = props.items || [
            { productId, product: props.product, quantity: 1 },
        ];
        const analyticsProducts = [];
        let currencyCode;

        products.forEach((item) => {
            const isInShoppingList = shoppingList.some(
                (x) => x.productId == item.productId
            );

            if (isInShoppingList) {
                dispatch(remove(item.productId));
                return;
            }

            let product = item.product;
            if (isJSONString(product)) {
                product = JSON.parse(product);
            }

            currencyCode =
                currencyCode ||
                product.currencyCode ||
                product.CurrencyCode ||
                product.Currency?.Id;
            analyticsProducts.push({
                name: product.name || product.Name,
                id: product.id || product.Id,
                price:
                    product.priceExcludingVat ??
                    product.PriceExcludingVat ??
                    product.Price?.Price?.Price,
                priceWithVat:
                    product.priceIncludingVat ??
                    product.PriceIncludingVat ??
                    product.Price?.Price?.PriceWithVat,
                quantity: item.quantity || 1,
                ...(props.analyticsListName && { list_name: props.analyticsListName }),
            });

            dispatch(add(item.productId));
            if (item.quantity > 1) {
                dispatch(setQuantity(item.productId, item.quantity));
            }
        });

        if (analyticsProducts.length > 0) {
            googleAnalytics({
                event: 'addToWishlist',
                ...(props.analyticsListName && { list_name: props.analyticsListName }),
                ecommerce: {
                    currencyCode,
                    add: {
                        products: analyticsProducts,
                    },
                },
            });
        }
        return true;
    };
    const Button = withReactiveStyleBuyButton(
        ReorderButton,
        onClick,
        `shoppinglist__btn__outer`
    );
    return <Button {...props} />;
};
export default StyledButton;
